import { useAuth0 } from "@auth0/auth0-react"
import { Button } from "@mui/material"
import { useTranslation } from "react-i18next"

type LoginButtonProps = {
  returnTo?: string
}

const LoginButton = ({ returnTo }: LoginButtonProps) => {
  const { loginWithRedirect } = useAuth0()
  const { t } = useTranslation()
  return (
    <Button
      id="login-button"
      data-testid="login-btn"
      variant="contained"
      onClick={() =>
        loginWithRedirect(returnTo ? { appState: { returnTo } } : undefined)
      }
      sx={{
        textTransform: "none",
        width: "200px",
      }}
    >
      {t("login")}
    </Button>
  )
}

export default LoginButton
